<template>
  <el-dialog
    title="缓存读取"
    :visible.sync="visible"
    @close="onClose"
    width="810px">
    <el-table
      :data="table.slice((pagination.current_page - 1) * pagination.per_page, pagination.current_page * pagination.per_page)"
      stripe
      highlight-current-row
      border
      v-loading="loading"
      element-loading-text="正在读取缓存中……"
      style="width: 100%">
      <el-table-column prop="key"
                       label="KEY"></el-table-column>
      <el-table-column prop="created_at"
                       label="创建日期"
                       width="185"></el-table-column>
      <el-table-column prop="updated_at"
                       label="更新日期"
                       width="185"></el-table-column>
      <el-table-column fixed="right"
                       label="操作"
                       width="80">
        <template slot-scope="scope">
          <el-button type="warning"
                     size="mini"
                     @click="onRead(scope.row.key)">读取
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <div style="margin-top: 15px;">
      <el-pagination background
                     layout="total, prev, pager, next, jumper"
                     @current-change="handleCurrentPageChange"
                     :current-page="pagination.current_page"
                     :page-size="pagination.per_page"
                     :total="pagination.total">
      </el-pagination>
    </div>
    <span slot="footer"
          class="dialog-footer">
      <el-button @click="handleAction('cancel')">关 闭</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  components: {},
  props: {},
  data () {
    return {
      visible: false,
      action: '',
      loading: false,
      key: null,
      table: [],
      pagination: {
        current_page: 1,
        per_page: 4,
        total: 0,
      },
    }
  },
  computed: {},
  watch: {
    visible () {
      this.table = []
      if (this.visible) {
        this.cache.table(this.key).then((table) => {
          if (table) {
            this.table = table.reverse()
            this.pagination.total = this.table.length
          }
        })
      }
    },
  },
  created () {},
  mounted () {},
  destroyed () {},
  methods: {
    onRead (key) {
      this.cache.getVersion(key).then((value) => {
        this.handleAction('confirm', value)
      })
    },
    handleCurrentPageChange (val) {
      this.pagination.current_page = val
    },
    handleAction (action, value) {
      this.action = action
      this.doClose(value)
    },
    onClose () {
      if (!this.visible) return
      this.handleAction('close')
    },
    doClose (value) {
      if (!this.visible) return
      this.visible = false
      setTimeout(() => {
        if (this.action) this.callback(this.action, value)
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/question-editor/components/question-cache-box/src/main.vue